import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import Level1 from "./Level1";
import Level2 from "./Level2";
import Level3 from "./Level3";
import Level4 from "./Level4";
import Level5 from "./Level5";
import Level6 from "./Level6";
import Level7 from "./Level7";
import Level8 from "./Level8";
import Detail from "../../main/detail/Detail";
import { UseProduct } from "./UseProduct";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";

export default function AddProduct() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  var body = {};
  const [expanded, setExpanded] = React.useState("panel1");
  const { addProduct } = UseProduct();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const location = useLocation();
  const navigate = useNavigate();
  const [fireGetData, setFireGetData] = React.useState(false);
  const [open, setOpen] = useState(false);

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: "/products",
        title: "محصولات",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/products" },
          { name: "افزودن محصول", url: "/products/addproduct" },
        ],
      }}
    >
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle color="red" id="alert-dialog-title">
          توجه!
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            آیا از ثبت نهایی محصول اطمینان دارید ؟
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ color: "#565656 !important" }}
            onClick={() => AddProduct()}
          >
            بله
          </Button>
          <Button color="secondary" onClick={() => setOpen(false)}>
            خیر
          </Button>
        </DialogActions>
      </Dialog>
      <Box>
        <Level1
          expanded={expanded}
          setExpanded={setExpanded}
          fireGetData={fireGetData}
          getDataFromLevel1={getDataFromLevel1}
        />
        <Level2
          expanded={expanded}
          setExpanded={setExpanded}
          fireGetData={fireGetData}
          getDataFromLevel2={getDataFromLevel2}
        />
        <Level3
          expanded={expanded}
          setExpanded={setExpanded}
          fireGetData={fireGetData}
          getDataFromLevel3={getDataFromLevel3}
        />
        <Level4
          expanded={expanded}
          setExpanded={setExpanded}
          fireGetData={fireGetData}
          getDataFromLevel4={getDataFromLevel4}
        />

        <Level5
          expanded={expanded}
          setExpanded={setExpanded}
          fireGetData={fireGetData}
          getDataFromLevel5={getDataFromLevel5}
        />

        <Level6
          expanded={expanded}
          setExpanded={setExpanded}
          fireGetData={fireGetData}
          getDataFromLevel6={getDataFromLevel6}
        />
        <Level7
          expanded={expanded}
          setExpanded={setExpanded}
          fireGetData={fireGetData}
          getDataFromLevel7={getDataFromLevel7}
        />
        <Level8
          expanded={expanded}
          setExpanded={setExpanded}
          fireGetData={fireGetData}
          getDataFromLevel8={getDataFromLevel8}
        />
        <Box sx={{ display: "flex", justifyContent: "flex-end", m: 2 }}>
          <Button
            sx={{ width: "100px" }}
            color="secondary"
            variant="contained"
            onClick={() => setOpen(true)}
          >
            ثبت نهایی
          </Button>
        </Box>
      </Box>
    </Detail>
  );

  function getDataFromLevel1(level1) {
    body.brandID = level1.brandID;
    body.categoryID = level1.categoryID;
    body.faName = level1.faName;
    body.enName = level1.enName;
    body.companyID = level1.companyID;
    body.countryID = level1.countryID;
    body.licenceCountryID = level1.licenceCountryID;
  }

  function getDataFromLevel2(level2) {
    body.typeID = level2.typeID;
    body.materialID = level2.materialID;
    body.sizeID = level2.sizeID;
    body.colorID = level2.colorID;
    body.tasteID = level2.tasteID;
    body.scentID = level2.scentID;
    body.consumerAge = level2.consumerAge;
    body.countInPack = level2.countInPack;
    body.weight = level2.weight;
    body.shieldID = level2.shieldID;
  }

  function getDataFromLevel3(level3) {
    body.registerCode = level3.registerCode;
    body.gender = level3.gender;
    body.spf = level3.spf;
    body.targetLocationID = level3.targetLocationID;
    body.modelID = level3.modelID;
    body.appropriateID = level3.appropriateID;
  }

  function getDataFromLevel4(level4) {
    body.groupID = level4.groupID;
  }

  function getDataFromLevel5(level5) {
    body.characteristics = level5.characteristics;
    body.warnings = level5.warnings;
    body.appurtenances = level5.appurtenances;
    body.keepConditions = level5.keepConditions;
    body.usages = level5.usages;
  }

  function getDataFromLevel6(level6) {
    body.description = level6.description;
    body.usageWay = level6.usageWay;
    body.sumDescription = level6.sumDescription;
    body.metaDescription = level6.metaDescription;
  }

  function getDataFromLevel7(level7) {
    body.ingredientCount = level7.ingredientCount;
    body.ingredients = level7.ingredients;
  }

  function getDataFromLevel8(level8) {
    body.isNatural = level8.isNatural;
    body.isHerbal = level8.isHerbal;
    body.isTraditional = level8.isTraditional;
    body.isOnlineSell = level8.isOnlineSell;
    body.discontinue = level8.discontinue;
    body.isSuspend = level8.isSuspend;
    let isOmomi = body.gender == 0;
    let newBody = Object.fromEntries(
      Object.entries(body).filter(([_, v]) => v != "" && v !== false),
    );
    if (isOmomi) {
      newBody.gender = 0;
    }
    postData(newBody);
  }

  function AddProduct() {
    setFireGetData(true);
  }

  function postData(newBody) {
    setProgress(true);
    addProduct(
      newBody,
      () => {
        setMsGotoLast(true);
        navigate("/products", {
          state: location.state,
          replace: true,
        });
      },
      setFireGetData,
    );
  }
}
